import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { sonic } from 'wagmi/chains';

import { type Chain } from 'viem'


export const juchain = {
  id: 210000,
  name: 'JuChain',
  nativeCurrency: { name: 'JuCoin', symbol: 'JU', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.juchain.org'] },
  },
  blockExplorers: {
    default: { name: 'juscan', url: 'https://juscan.io' },
  },
} as const satisfies Chain

export const juchainTestnet = {
  id: 202599,
  name: 'JuChain Testnet',
  nativeCurrency: { name: 'JuCoinTest', symbol: 'JU', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://testnet-rpc.juchain.org'] },
  },
  blockExplorers: {
    default: { name: 'juscan', url: 'https://testnet.juscan.io' },
  },
} as const satisfies Chain

export const BSC_RPC_NODES = [
  'https://bsc-dataseed.bnbchain.org',
  'https://bsc-dataseed.nariox.org',
  'https://bsc-dataseed.defibit.io',
  'https://bsc-dataseed.ninicoin.io',
  'https://bsc.nodereal.io',
  'https://bsc-dataseed-public.bnbchain.org',
  'https://bnb.rpc.subquery.network/public',
];

const getRandomRPCNode = () => {
  const randomIndex = Math.floor(Math.random() * BSC_RPC_NODES.length);
  return BSC_RPC_NODES[randomIndex];
};
export const BSC_RPC = {
  id: 56,
  name: 'BNB Smart Chain',
  nativeCurrency: {
    decimals: 18,
    name: 'BNB',
    symbol: 'BNB',
  },
  rpcUrls: {
    default: { http: [getRandomRPCNode()] },
  },
  blockExplorers: {
    default: {
      name: 'BscScan',
      url: 'https://bscscan.com',
      apiUrl: 'https://api.bscscan.com/api',
    },
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 15921452,
    },
  },
} as const satisfies Chain
export const config = getDefaultConfig({
  appName: 'YOLOPad',
  projectId: '064a385b821b8d0eb0df7e5d5ea08d94',
  chains: [
    BSC_RPC,
    // sonic,
    // juchain,
  ],
  ssr: true,
});
